import React, { useEffect, useRef, useState } from "react";
import { useI18n } from "../i18n/I18nContext";
import { ASSETS } from "../lib/assets";

export const VideoSection = () => {
  const { lang, t } = useI18n();
  const videoRef = useRef(null);
  const [played, setPlayed] = useState(false);

  // Reload video element when language changes
  useEffect(() => {
    const v = videoRef.current;
    if (v) {
      setPlayed(false);
      v.load();
    }
  }, [lang]);

  const src = ASSETS.videos[lang] || ASSETS.videos.en;

  const handlePlay = () => {
    const v = videoRef.current;
    if (!v) return;
    setPlayed(true);
    const p = v.play();
    if (p && typeof p.catch === "function") p.catch(() => { /* autoplay block — user will press native play */ });
  };

  return (
    <section
      id="video"
      data-testid="video-section"
      className="relative max-w-7xl mx-auto px-4 sm:px-6 py-20 md:py-28"
    >
      <div className="flex items-center justify-between mb-8">
        <div>
          <div className="section-tag">{t.video.title}</div>
          <h2 className="font-pixel text-[#ffe600] glow-yellow text-4xl sm:text-5xl mt-2 tracking-widest">
            {t.video.title}
          </h2>
          <p className="font-mono text-[#94a3b8] text-sm mt-2">{t.video.caption}</p>
        </div>
        <div className="hidden md:flex items-center gap-3 font-pixel text-[#00ffff] glow-cyan text-lg tracking-widest">
          <span>CH&nbsp;01</span>
          <span className="w-2 h-2 bg-[#ff0044] rounded-full blink" />
          <span>REC</span>
        </div>
      </div>

      <div className="crt-screen">
        <div className="crt-screen-inner aspect-video bg-black">
          <video
            ref={videoRef}
            data-testid="promo-video"
            key={lang}
            controls={played}
            playsInline
            preload="metadata"
            onPlay={() => setPlayed(true)}
            onEnded={() => setPlayed(false)}
            className="block w-full h-full object-contain bg-black"
          >
            <source src={`${src}#t=0.1`} type="video/quicktime" />
            <source src={`${src}#t=0.1`} type="video/mp4" />
            Your browser does not support the video tag.
          </video>

          {!played && (
            <button
              type="button"
              data-testid="video-play-overlay"
              onClick={handlePlay}
              aria-label="Play video"
              className="absolute inset-0 w-full h-full flex flex-col items-center justify-center gap-4 bg-black/30 hover:bg-black/20 transition-colors cursor-pointer group"
            >
              <span className="font-pixel text-[#ffe600] glow-yellow text-6xl sm:text-7xl tracking-widest blink">▶ PLAY</span>
              <span className="font-pixel text-[#00ffff] glow-cyan text-lg tracking-[0.4em]">PRESS START</span>
            </button>
          )}
        </div>
        <div className="mt-3 flex items-center justify-between font-pixel text-[#94a3b8] text-base tracking-widest">
          <span>● PLAY  ■ STOP  ▶▶ FFWD</span>
          <span>LANG: <span className="text-[#00ffff] glow-cyan">{lang.toUpperCase()}</span></span>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
